export default __webpack_public_path__ + "static/media/headphones.7ca63fad.jpg";